import gql from 'graphql-tag'

export const ReportColumnsFetchQuery = gql`
  query ReportColumnsFetch($project_id: Int!, $report_version: ReportVersion!) {
    report_columns(project_id: $project_id, report_version: $report_version) {
      uid
      name
      group
    }
  }
`

export const CreateFinalReport = gql`
  mutation createJobs($project_id: Int, $type: String = "WlWelds::Jobs::FinalReport", $args: String) {
    createJobs(project_id: $project_id, type: $type, args: $args) {
      job {
        id
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/components/Projects/final_report/mutations.js